module.exports = __webpack_public_path__ + "img/ireland-logo-icon.1853ef18.png";